<template>
  <div>
    <h1 id="jump-to-header">{{heading || "View"}}</h1>
    <b-card bg-variant="light">
      <b-row>
        <b-col md="4">
          <brand-show :id="id" @gotAttrs="assignAttrs"></brand-show>
        </b-col>
        <b-col md="8">
          <!-- <b-tabs
            active-nav-item-class="font-weight-bold text-uppercase text-warning"
            active-tab-class="font-weight-bold text-success"
            content-class="mt-3"
            lazy
          >
            <b-tab title="Product Models" active> -->
              <product-model-index
                :filtering="filtering"
                :ams_template="ams_template"
              ></product-model-index>
            <!-- </b-tab>
          </b-tabs> -->
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import BrandShow from './BrandShow.vue'
import ProductModelIndex from './ProductModelIndex.vue'

export default {
  components: {
    BrandShow,
    ProductModelIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      filtering: {
        brand_ids: this.id
      },
      ams_template: {
        type: 'product-models',
        description: undefined,
        attributes: {
          'brand-id': this.id
        }
      },
      attrs: {},
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.attrs = Object.assign( {}, attrs)
      this.ams_template.description = description + ' ' + this.attrs['name']
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>